const MenuRoute = [
  {
    title: "Home",
    path: "/",
    isActive: "",
  },
  {
    title: "Trucking",
    path: "/truck",
    isActive: "truck",
  },
  {
    title: "Cargo",
    path: "/cargo",
    isActive: "cargo",
  },
  {
    title: "Warehouse",
    path: "/warehouse",
    isActive: "warehouse",
  },
  {
    title: "Corporate Solution",
    path: "/corporate",
    isActive: "corporate",
  },
  {
    title: "Tracking",
    path: "/tracking",
    isActive: "tracking",
  },
];

export default MenuRoute;
